import React from "react";
import "../loader/loader.css";
const Loader: React.FC<{}> = () => <div className="loader">Loading...</div>;

export default Loader;
